import service from './baseService';
import { getModelTypeIDAndEntityID } from '../config';

export const getPayrollEntriesService = (payrollPeriodID) => {
    return service.get(`/driver-payroll-entries`, {
        params: { ...getModelTypeIDAndEntityID(), payrollPeriodID },
    });
};

export const certifyPayrollSummaryService = (payrollPeriodID) => {
    return service.post(`driver-payroll-entries/certify-payroll-summary`, {
        ...getModelTypeIDAndEntityID(),
        payrollPeriodID,
    });
};
